import { Link } from 'react-router-dom';
import './insurance.scss';

export default function CPGKeyMotivator() {
  return (
    <>
      <h5>Key Motivator for Insurance Companies</h5>
      <p>Achieving easier personalization would be insurance companies’ top motivator for increasing direct mail use going forward.</p>
      <ul>
        <li><strong><a href="/../4-ways-to-grow-your-business-with-metered-mail/">Using a postage meter</a></strong> makes it easy to personalize your envelopes with tailored messaging, as well as company branding.</li>
      </ul>
    </>
  );
}
